<!DOCTYPE html>
<html>

<head>
  <meta charset="utf-8" />
  <title>Top-up Wallet</title>
  <link href="https://fonts.googleapis.com/css2?family=Poppins&display=swap" rel="stylesheet" />

  <style>
    body {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 100vh;
      margin: 0;
      font-size: 16px;
      background-color: #f2f2f2;
      font-family: "Poppins", sans-serif;
      color: #333;
    }

    .container {
      position: relative; 
      width: 50%;
      height: 20rem;
      max-width: 400px;
      margin: 0 auto;
      background-color: #fff;
      padding: 20px;
      border-radius: 10px;
      box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
      text-align: center;
      min-height: 300px;
      overflow: hidden; 
    }

    .button_style {
      background-color: rgb(74, 11, 119);
      color: white;
      margin: 0.5rem;
      padding: 0.5rem 1rem;
      text-decoration: none;
      border-radius: 5px;
    }

    .reach-us-text {
      color: #141618;
      font-size: 15px;
      font-style: normal;
      font-weight: 400;
      line-height: 20px;
      letter-spacing: -0.5px;
    }

    .reach-us-link {
      position: relative;
      z-index: 10;
      cursor: pointer;
      color: #991dc6;
      font-size: 15px;
      font-style: normal;
      font-weight: 400;
      line-height: 20px;
      letter-spacing: -0.5px;
    }

    .button_style:hover {
      background-color: #5246b5;
    }

    .logo {
      width: 160px;
      height: auto;
      /* margin-bottom: 1rem; */
      display: flex;
    }

    .sign-animation {
      position: absolute;
      top: 55%; 
      left: 50%;
      transform: translate(-50%, -50%);
      width: 100%;
      height: auto;
      z-index: 0;
      pointer-events: none; 
      object-fit: contain;
    }

    .title_five {
      text-align: center;
    }

    @media screen and (max-width: 415px) {
      .title_five {
        font-size: 17px !important;
      }

      .container {
        width: 67%;
      }
    }

    @media screen and (min-width: 415px) and (max-width: 620px) {
      .title_five {
        font-size: 1.3rem !important;
      }
      .container {
        width: 67%;
      }
    }

    @media (max-width: 768px) {
      body {
        font-size: 14px;
      }

      .button_style {
        padding: 0.8rem 1.5rem;
      }
    }

    @media (max-width: 480px) {
      body {
        font-size: 12px;
      }

      .container {
        padding: 15px;
      }

      .button_style {
        padding: 0.7rem 1.3rem;
      }
    }
  </style>
</head>

<body>
<div class="container">
  <div style="display: flex; justify-content: center; align-items: center;">
    <img src="../../assets/img/new-logo.png" height="80" alt="Logo" class="logo" />
  </div>
  <img *ngIf="isSuccess === true" src="/assets/img/animation-crop.gif" class="sign-animation" alt="animation">

  <div class="margin-paragraph">
    <div style="margin-top: 1rem; text-align: center; margin-bottom: 2rem; height: 20rem;">
      
     <div *ngIf="isSuccess === false" style="display: flex; justify-content: center">
        <img src="../../../assets/img/sign-cancelled.png" height="150" />
     </div>

      <div style="display: flex; justify-content: center">
        <p *ngIf="isSuccess === null" style="padding-top: 1rem; font-size: 1.5rem; font-weight: 700; color: #3d3d3d;">
          Verifying Payment...
        </p>
        <p *ngIf="isSuccess === false" style="font-size: 1.2rem; font-weight: 700; color: red;">
          Payment Failed
        </p>
      </div>

      <div *ngIf="isSuccess === true">
        <p class="title_five" style="padding-top: 1rem; color: #3d3d3d; font-size: 1.5rem; font-weight: 700">
          Top-up Successful!
        </p>
        <p style="font-size: 1rem; text-align: center; margin-top: 1rem;">
          Transaction ID: <u>{{ orderId }}</u>
        </p>
        <div style="font-weight: 800; margin-top: 20px">The amount has been added to your wallet.</div>
        
        <p class="reach-us-text text-center my-4">
          Click here to <button class="reach-us-link" (click)="goToDashboard()" style="border:none; background:none; padding:0;">
            <span style="font-weight: 800; cursor: pointer; text-decoration: underline;">view wallet</span>
          </button>
        </p>
      </div>

      <div *ngIf="isSuccess === false" class="mt-1">
         <p class="reach-us-text text-center my-1">
          Click here to <button class="reach-us-link" (click)="goToDashboard()" style="border:none; background:none; padding:0;">
            <span style="font-weight: 800; cursor: pointer; text-decoration: underline;">view wallet</span>
          </button>
        </p>
      </div>

    </div>
  </div>
</div>
</body>

</html>